/**
 * How a training evaluation's verdict (aiEvaluation.passFail) is shown.
 *
 * needs_review (PD-08, 24 Sep 2026): the evaluator did not score a dimension,
 * or scored a dimension with critical-fail criteria at 20% or less without
 * flagging an automatic fail. The scores stand but carry no verdict; a person
 * judges. critical_fail comes only from the evaluator's automatic_fail flag.
 */
export function verdictChip(passFail, { therapistPractice = false } = {}) {
  if (passFail === 'needs_review') return { label: 'NEEDS REVIEW', color: 'info' };
  if (passFail === 'critical_fail') return { label: 'CRITICAL FAIL', color: 'error' };
  if (therapistPractice) {
    return passFail === 'pass'
      ? { label: 'On track', color: 'success' }
      : { label: 'Areas to revisit', color: 'warning' };
  }
  return passFail === 'pass'
    ? { label: 'PASS', color: 'success' }
    : { label: 'NEEDS IMPROVEMENT', color: 'warning' };
}

/** A score chip's colour: success for a pass, info while under review. */
export function verdictColor(passFail) {
  if (passFail === 'pass') return 'success';
  if (passFail === 'needs_review') return 'info';
  if (passFail === 'critical_fail') return 'error';
  return 'warning';
}
